import ApplicationController from './application'

export default class extends ApplicationController {

  static targets = ['select', 'custom', 'customWrap', 'hidden', 'toggle']
  static values  = { current: Number, min: Number, allowZero: Boolean, minMessage: String }

  connect() {
    if (!this.hasSelectTarget) return

    if (this.currentValue && !this.#matchesOption(this.currentValue)) {
      this.customTarget.value = this.currentValue / 100
      this.#enableOther()
    } else {
      this.#disableOther()
    }
  }

  toggleOther() {
    this.#isOther() ? this.#disableOther() : this.#enableOther()
    if (this.#isOther()) this.customTarget.focus()
  }

  sync() {
    const rands = parseFloat(this.customTarget.value)
    const cents = Number.isFinite(rands) ? Math.round(rands * 100) : ''
    this.hiddenTarget.value = cents
    this.#validateCustom(cents)
  }

  // Rule: a tradable value is either 0 (opt out, allow_zero fields only) or >= min.
  // Empty is left to native/presence handling. Keep this in sync with TradableAllowanceUpdate::LIMITS.
  #validateCustom(cents) {
    if (cents === '') return this.customTarget.setCustomValidity('')
    const valid = cents >= this.minValue || (this.allowZeroValue && cents === 0)
    this.customTarget.setCustomValidity(valid ? '' : this.minMessageValue)
  }

  #isOther() {
    return this.customWrapTarget.style.display !== 'none'
  }

  #enableOther() {
    this.customWrapTarget.style.display = ''
    this.selectTarget.style.display = 'none'
    this.selectTarget.disabled = true
    this.hiddenTarget.disabled = false
    this.sync()
    if (this.hasToggleTarget) this.toggleTarget.textContent = this.toggleTarget.dataset.onLabel
  }

  #disableOther() {
    this.customWrapTarget.style.display = 'none'
    this.selectTarget.style.display = ''
    this.selectTarget.disabled = false
    this.hiddenTarget.disabled = true
    if (this.hasToggleTarget) this.toggleTarget.textContent = this.toggleTarget.dataset.offLabel
  }

  #matchesOption(value) {
    return Array.from(this.selectTarget.options).some(
      (option) => option.value !== '' && Number(option.value) === Number(value)
    )
  }
}
